import React, { useState } from 'react';
import { BarChart3, Building2, FileBarChart, Calculator, Clipboard } from 'lucide-react';
import CostAccountingDashboard from './CostAccountingDashboard';
import CostCentersView from './CostCentersView';
import CostElementsView from './CostElementsView';
import ProductionCostsView from './ProductionCostsView';
import StandardCostsView from './StandardCostsView';

const CostAccountingView = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  const tabs = [
    { id: 'dashboard', name: '儀表板', icon: <BarChart3 className="h-5 w-5" /> },
    { id: 'costCenters', name: '成本中心', icon: <Building2 className="h-5 w-5" /> },
    { id: 'costElements', name: '成本要素', icon: <FileBarChart className="h-5 w-5" /> },
    { id: 'productionCosts', name: '生產成本', icon: <Calculator className="h-5 w-5" /> },
    { id: 'standardCosts', name: '標準成本', icon: <Clipboard className="h-5 w-5" /> },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <CostAccountingDashboard />;
      case 'costCenters':
        return <CostCentersView />;
      case 'costElements':
        return <CostElementsView />;
      case 'productionCosts':
        return <ProductionCostsView />;
      case 'standardCosts':
        return <StandardCostsView />;
      default:
        return <CostAccountingDashboard />;
    }
  };

  return (
    <div className="flex flex-col h-full">
      <div className="bg-white shadow-sm">
        <div className="flex space-x-1 p-2 overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                activeTab === tab.id
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-600 hover:text-gray-800 hover:bg-gray-100'
              }`}
            >
              <span className="mr-2">{tab.icon}</span>
              {tab.name}
            </button>
          ))}
        </div>
      </div>
      <div className="flex-grow overflow-auto bg-gray-50">
        {renderContent()}
      </div>
    </div>
  );
};

export default CostAccountingView;
